const sumArrays = (arr1: number[], arr2: number[]) => {
    const maxLength = Math.max(arr1.length, arr2.length);
    const result = [];
    for (let i = 0; i < maxLength; i++) {
        result.push((arr1[i] || 0) + (arr2[i] || 0));
    }
    return result;
};

export default sumArrays;
